module.exports = ".signup {\n  width: 40%;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/user/signup/signup.css
 ** module id = 333
 ** module chunks = 2
 **/